var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-6"},[_c('Visa'),_vm._v(" "),_c('Mastercard'),_vm._v(" "),_c('AmericanExpress'),_vm._v(" "),_c('Paypal'),_vm._v(" "),_c('ApplePay'),_vm._v(" "),_c('GooglePay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }